import { render, staticRenderFns } from "./BarnInterventionIncidentEventTriggerDialog.vue?vue&type=template&id=5cf65de0&scoped=true"
import script from "./BarnInterventionIncidentEventTriggerDialog.vue?vue&type=script&lang=js"
export * from "./BarnInterventionIncidentEventTriggerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf65de0",
  null
  
)

export default component.exports